import { toast } from "react-toastify";
import axiosInstance from "../../../../axiosInstance";
import { HRMS_ATS_API_URL } from "../../../Constants/baseConstant";
import { getDomain, getUserData, getUserId } from "../../Base/helper/baseFunctions";
import NProgress from 'nprogress';

export const GetEmployeeTargetManagementHelper = async (params) => {
    NProgress.start();
    const user = getUserData();
    return await axiosInstance(`/ats/user/getEmployeeTargetManagement`, {
        method: "POST",
        baseURL: HRMS_ATS_API_URL,
        data: {
            domain_name: getDomain(),
            month: params?.month,
            year: params?.year,
            user_id: getUserId(),
            is_grouporg: user?.grouporg_flow || false
        }
    })
        .then((res) => {
            NProgress.done();
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            NProgress.done();
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const UpdateEmployeeTargetManagementHelper = async (params) => {
    const user = getUserData();
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/ats/user/updateEmployeeTargetManagement`, {
        method: "POST",
        baseURL: HRMS_ATS_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            employee_fk: params?.employee_fk,
            month: params?.month,
            year: params?.year,
            record_date: params?.record_date,
            target: params?.target,
            comments: params?.comments || "",    
            is_grouporg: user?.grouporg_flow || false    
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Target updated successfully");
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message);
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}